import classNames from 'classnames';
import React from 'react';

import BoxLayout from 'sharedreact/components/BoxLayout';
import Button from 'sharedreact/components/Button';
import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  id: string,
  className?: string,
  visible?: boolean,
  alignRight?: boolean,
  children?: React.ReactNode,
  showfooterSeparator?: boolean,
  language?: string,
  noPanel?: boolean,
  headerClassName?: string,
  footerClassName?: string,
  canClose?: boolean,

  onClose?: (event?: React.MouseEvent<HTMLButtonElement>) => void,
  renderHeaderContent?: () => React.ReactNode,
  renderFooterContent?: () => React.ReactNode,
};

class SlideOut extends React.Component<Props> {
  renderHeader () {
    return (
      <div className={classNames('esko_slideoutheader', this.props.headerClassName)}>
        {this.props.renderHeaderContent != null ? this.props.renderHeaderContent() : null}
      </div>
    );
  }

  renderFooter () {
    if (this.props.renderFooterContent != null) {
      return (
        <div className={classNames('esko_slideoutfooter', this.props.footerClassName)}>
          {this.props.renderFooterContent != null ? this.props.renderFooterContent() : null}
        </div>
      );
    } else {
      const {
        id, alignRight, onClose,
        canClose, footerClassName
      } = this.props;
      if (onClose != null) {
        return (
          <BoxLayout className={classNames('esko_slideoutfooter', footerClassName, {'align-right': alignRight})} horizontal>
            <Button id={id + '_close'} onClick={onClose} disabled={!canClose}>{translate('shared.general.close')}</Button>
          </BoxLayout>
        );
      }
    }
    return null;
  }

  override render (): React.ReactNode {
    const {
      id,
      alignRight,
      className, showfooterSeparator,
      language, // eslint-disable-line no-unused-vars
      visible,
      children, noPanel
    } = this.props;

    const alignmentSuffix: string = alignRight ? '-right' : '-left';
    const eskoSlideOutClassNames: string = classNames(
      'esko_slideout',
      className,
      {'is-visible': visible},
      [`align${alignmentSuffix}`]
    );

    if (noPanel) {
      return (
        <div id={id + '_parent'} className={eskoSlideOutClassNames}>
          {children}
        </div>
      );
    } else {
      return (
        <div id={id + '_parent'} className={eskoSlideOutClassNames}>
          <div id={id} className='esko_slideoutpanel'>
            {this.renderHeader()}
            <div className='esko_slideoutcontent'>
              {children}
            </div>
            {showfooterSeparator
              ? <div className='esko_slideoutfiller'>
                <hr className='esko_slideoutbottomseparator' />
              </div>
              : null }
            {this.renderFooter()}
          </div>
        </div>
      );
    }
  }
}

export default SlideOut;
